import cs from '@/app/(site)/news/news.module.scss';
import PostCard from '@/components/Posts/PostCard';
import Link from 'next/link';
import { Post, PostFull } from '@api';
import React, { useMemo } from 'react';
import * as C from '@/components';
import * as Api from '@api';
import clsx from 'clsx';

export const NewsCategorySectionKeys = [
    "latest.sectionTitle",
    "industry-news.sectionTitle",
    "industry-news.sectionButton",
    "podcasts.sectionTitle",
    "podcasts.sectionButton",
    "articles.sectionTitle",
    "articles.sectionButton",
    "press.sectionTitle",
    "press.sectionButton",
] as const satisfies Api.ContentKey[];

export interface NewsCategorySectionProps {
  posts: Post[] | PostFull[];
  pageContent:  { [key: string]: any };
  category: string;
  visiblePostsCount?: number;
  isMore?: boolean;
}

export const NewsCategorySection = ({ posts, category, pageContent, visiblePostsCount = 6, isMore = true }: NewsCategorySectionProps) => {
    const buttonText = pageContent[`${category}.sectionButton`]?.data ?? "More";
    const visiblePosts = useMemo(() => (
        posts
            .filter((post) => {
                if (category === 'latest') {
                    return post.showInLatestNews;
                }
                return true;
            })
            .slice(0, visiblePostsCount)
    ), [category, posts, visiblePostsCount]);

    return posts.length > 0 ? <>
        <C.PageContent {...pageContent[`${category}.sectionTitle`]} typography={C.Typography.H3}
                            margins={{bottom: C.Margin.D24, x: C.Margin.Auto}}/>
        <div className={cs.news_list__wrapper}>
            {
                visiblePosts.map(post => (
                    <PostCard post={post} key={post.id}/>
                ))
            }
        </div>
        {isMore && <div className={clsx('text-center', posts.length <= visiblePostsCount && 'hidden')}>
            <Link href={`/news/category/${category}`} className="btn-yellow-arrow mb-10">
              <span>{buttonText}</span>
            </Link>
        </div>}
  </> : <></>;
}
